document.addEventListener('DOMContentLoaded', () => {
  document.documentElement.classList.add('el-motion-ready');
  const menuButton = document.querySelector('[data-el-menu-toggle]');
  const menu = document.querySelector('[data-el-menu]');
  menuButton?.addEventListener('click', () => {
    const open = menuButton.getAttribute('aria-expanded') === 'true';
    menuButton.setAttribute('aria-expanded', String(!open));
    menu?.classList.toggle('is-open', !open);
  });
  document.querySelectorAll('[data-el-carousel]').forEach((root) => {
    const slides = [...root.querySelectorAll('[data-el-slide]')];
    const dots = [...root.querySelectorAll('[data-el-dot]')];
    const count = root.querySelector('[data-el-count]');
    if (!slides.length) return;
    let index = 0;
    const show = (next) => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => { const active = i === index; slide.classList.toggle('is-active', active); slide.setAttribute('aria-hidden', active ? 'false' : 'true'); });
      dots.forEach((dot, i) => i === index ? dot.setAttribute('aria-current', 'true') : dot.removeAttribute('aria-current'));
      if (count) count.textContent = (index + 1) + ' / ' + slides.length;
    };
    root.querySelector('[data-el-prev]')?.addEventListener('click', () => show(index - 1));
    root.querySelector('[data-el-next]')?.addEventListener('click', () => show(index + 1));
    dots.forEach((dot, i) => dot.addEventListener('click', () => show(i)));
    root.addEventListener('keydown', (event) => { if (event.key === 'ArrowLeft') show(index - 1); if (event.key === 'ArrowRight') show(index + 1); });
  });
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => entries.forEach((entry) => { if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); } }), { threshold: .12 }) : null;
  document.querySelectorAll('[data-el-reveal]').forEach((element) => observer ? observer.observe(element) : element.classList.add('is-visible'));
});
